/**
 * Tenant Storage Configuration — Frontend
 *
 * Keep in sync with supabase/functions/_shared/storage-config.ts
 */

/** The single private bucket for all tenant files */
export const TENANT_BUCKET = 'tenants';

/** Signed URL TTL in seconds (frontend only needs FRONTEND) */
export const SIGNED_URL_TTL = {
  FRONTEND: 3600, // 1 hour
} as const;

/** Frontend cache TTL in milliseconds (50 min — before 1hr URL expiry) */
export const FRONTEND_CACHE_TTL_MS = 50 * 60 * 1000;

/** Max cache entries before LRU eviction */
export const FRONTEND_CACHE_MAX_ENTRIES = 500;

/** Number of entries to evict when cache is full */
export const FRONTEND_CACHE_EVICT_COUNT = 100;

// ============================================================================
// PATH EXTRACTION — Frontend mirror of backend extractStoragePath
// ============================================================================

/**
 * Extract storage path from URL or return path as-is.
 * Returns null for external URLs (not our storage).
 * Mirrors backend _shared/media-url-utils.ts extractStoragePath().
 */
export function extractStoragePath(urlOrPath: string | null | undefined): string | null {
  if (!urlOrPath || typeof urlOrPath !== 'string') return null;

  const trimmed = urlOrPath.trim().split('?')[0];
  if (!trimmed) return null;

  if (trimmed.startsWith('http')) return null;

  return trimmed;
}
